require('../bootstrap');

import env from '../config/loadEnv';
import router from '../router/index'

const baseURL = env.baseURL;
const normalURL = env.normalURL;
const applicationName = env.applicationName;
const footerName = env.footerName;

const store = {
    state: {
        user: {
            name: '',
            photo: '',
            job: '',
            email: '',
            is_admin: '',
            id: 0
        },
        authenticated: false,
        token: '',
        api: baseURL,
        url: normalURL,
        applicationName: applicationName,
        footerName: footerName,
        breadcrumbs: [{ name: "Home", route: "/" }]
    },
    getters: {
        token: state => {
            return state.token;
        },
        authenticated: state => {
            if (state.token == null || state.token == 'null') {
                return false;
            }

            return state.authenticated;
        },
        logo: state => {
            return state.logo;
        },
        user: state => {
            return state.user;
        },
        api: state => {
            return state.api;
        },
        breadcrumbs: state => {
            return state.breadcrumbs;
        }
    },
    mutations: {
        auth(state, token) {

            if (token != null && token != undefined) {
                state.authenticated = true;
                state.token = token;

                localStorage.clear();
                localStorage.setItem('token', token);

                axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('token');
                this.commit('profileUpdate');
            }
        },
        profileUpdate(state) {
            axios.post(state.api + 'me', {
                token: state.token
            })
                .then(response => {
                    state.user.id = response.data.id;
                    state.user.name = response.data.name;
                    state.user.email = response.data.email;
                    state.user.photo = state.url + "user/image/" + response.data.id;
                    state.user.matriculation = response.data.matriculation;
                    state.user.rg = response.data.rg;
                    state.user.cpf = response.data.cpf;
                    state.user.cellphone = response.data.cellphone;
                    state.user.date_of_birth = response.data.date_of_birth;
                    state.user.number_cnh = response.data.number_cnh;
                    state.user.validity_cnh = response.data.validity_cnh;
                    state.user.pri_cnh = response.data.pri_cnh;
                    state.user.cat_cnh = response.data.cat_cnh;
                    state.user.admission_date = response.data.admission_date;
                    state.user.access_nivel = response.data.access_nivel;
                    state.user.department_id = response.data.department_id;
                    state.user.accept_terms = response.data.accept_terms;

                    if (state.user.cpf == null) {
                        router.push('/profile');
                    }


                    localStorage.setItem('accept_terms', response.data.accept_terms);
                    localStorage.setItem('access_nivel', response.data.access_nivel);

                })
                .catch(error => {
                    localStorage.clear();

                    router.push('/login');
                });
        },
        updateBreadCrumbs(state, newRoute) {
            if (state.breadcrumbs.length > 1) {
                state.breadcrumbs.pop();
            }
            state.breadcrumbs.push(newRoute)
            // state.breadcrumbs = newRoute;
        }
    },
    actions: {
        initialize(context) {
            const token = localStorage.getItem('token');

            context.commit('auth', token);
        }
    }
};

export default store;



// WEBPACK FOOTER //
// ./src/store/index.js